/**
 * Recommended Products Component
 * Handles Swiper initialization and dynamic loading for recommended product carousels
 */
class RecommendedProducts {
    constructor() {
      this.swiperInstances = new Map();
      this.init();
    }
  
    init() {
      this.initIntersectionObserver();
      this.initExistingSwipers();
    }

    initIntersectionObserver() {
      const productRecommendationsSection = document.querySelector('.product-recommendations');
      
      if (!productRecommendationsSection) return;

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;
        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
              // Initialize Swiper after content is loaded
              this.initSwiper(productRecommendationsSection);
            }
          })
          .catch(e => {
            console.error('Error loading product recommendations:', e);
          });
      };

      const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: '0px 0px 200px 0px'
      });

      observer.observe(productRecommendationsSection);
    }

    initExistingSwipers() {
      const swiperElements = document.querySelectorAll('.recommended-products-swiper');
      
      if (swiperElements.length === 0) return;

      swiperElements.forEach((element) => {
        this.initSwiper(element);
      });
    }
  
    initSwiper(container) {
      const swiperElement = container.querySelector ? 
        container.querySelector('.recommended-products-swiper') : 
        container;
      
      if (!swiperElement) return;

      // Check if Swiper is already initialized
      if (swiperElement.swiper) return;

      const swiperId = swiperElement.getAttribute('data-swiper-id') || 
        `swiper-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      
      swiperElement.setAttribute('data-swiper-id', swiperId);

      const swiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        loop: true,
        navigation: {
          nextEl: container.querySelector ? 
            container.querySelector('#recommended-products-next') : 
            document.querySelector('#recommended-products-next'),
          prevEl: container.querySelector ? 
            container.querySelector('#recommended-products-prev') : 
            document.querySelector('#recommended-products-prev'),
        },
        breakpoints: {
          320: {
            slidesPerView: 'auto',
            spaceBetween: 0,
          },
          480: {
            slidesPerView: 'auto',
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 'auto',
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 0,
          },
        },
      });

      this.swiperInstances.set(swiperId, swiper);
    }
  }
  
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new RecommendedProducts();
  });
  
  // Export for potential external use
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = RecommendedProducts;
  }
  
  